var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20, type: "flex", justify: "start" } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "BTN",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addUser.init()
                    }
                  }
                },
                [_vm._v("添加用户")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.tableData.length
        ? _c(
            "el-table",
            { attrs: { data: _vm.tableData, border: "" } },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "60" }
              }),
              _c("el-table-column", {
                attrs: { prop: "nickname", label: "昵称" }
              }),
              _c("el-table-column", {
                attrs: { prop: "email", label: "账号" }
              }),
              _c("el-table-column", {
                attrs: { prop: "auth_group_name", label: "角色名称" }
              }),
              _c("el-table-column", {
                attrs: { label: "状态" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          row.status == 0
                            ? _c("span", { staticClass: "statusTag1" }, [
                                _vm._v("禁用")
                              ])
                            : _vm._e(),
                          row.status == 1
                            ? _c("span", { staticClass: "statusTag2" }, [
                                _vm._v("正常")
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4134895650
                )
              }),
              _c("el-table-column", {
                attrs: { prop: "coach_name", label: "关联教练" }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "200",
                  align: "center",
                  fixed: "right"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "x-c" }, [
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.handleDisable(row.id)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(row.status == 0 ? "启用" : "禁用")
                                )
                              ]
                            ),
                            _c("div", { staticClass: "controlsBtn-vertical" }),
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.$refs.addUser.init(row.id)
                                  }
                                }
                              },
                              [_vm._v("修改")]
                            ),
                            _c("div", { staticClass: "controlsBtn-vertical" }),
                            _c(
                              "div",
                              {
                                staticClass: "controlsBtn",
                                on: {
                                  click: function($event) {
                                    return _vm.handleDelete(row.id)
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3491283922
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              "page-size": 10
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("addUser", {
        ref: "addUser",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("appidPup", { ref: "appidPup" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }